import queryString from "query-string";
import React from "react";
import { Button } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { ReduxState } from "../../../../redux";
import {
  createTemplateFn,
  updateTemplateFn,
} from "../../../../redux/reducers/TemplateField/templates/server";
import { mapTemplateFieldFromClientToServer } from "../../../../redux/reducers/TemplateFieldUtils";
import { getCustomUi } from "../../../Docuclipper/ConfirmAlert/ConfirmAlert";
import Dropzone3 from "../../../Docuclipper/Dropzone3";
import { LoadingTrackedButton } from "../../../Docuclipper/TrackedButton";
import RouteLeavingGuard from "../RouteLeavingGuard";

type Props = {};
const SaveTemplate2: React.SFC<Props & RouteComponentProps> = ({
  history,
  location,
}) => {
  const { template, canvasMode, templateFields } = useSelector(
    (state: ReduxState) => state.TemplateField
  );
  const { loading } = template;
  const dispatch = useDispatch();

  const { action: actionQS } = queryString.parse(location.search);
  const [action] = React.useState(actionQS);

  const mode =
    template && template.template && template.template.id !== undefined
      ? "update"
      : "create";
  const btnText = mode === "create" ? "Create template" : "Update template";

  const [hasChanges, setHasChanges] = React.useState(true);

  let btnDisabled = false;
  if (mode === "create") {
    btnDisabled = templateFields.length === 0;
  } else if (mode === "update") {
    if (!template.template || templateFields.length === 0) {
      btnDisabled = true;
    } else {
      const newTemplate = JSON.stringify({
        rectangles: templateFields.map((tf) =>
          mapTemplateFieldFromClientToServer(tf)
        ),
      });
      const oldTemplate = template.template?.template;
      btnDisabled = newTemplate === oldTemplate;
    }
  }

  if (canvasMode !== "rectangles") {
    return null;
  }
  const { cd } = queryString.parse(location.search);
  return (
    <>
      {mode === "update" && cd && (
        <Dropzone3
          accept={["application/pdf"]}
          multiple={false}
          renderNext={() => null}
        />
      )}
      <RouteLeavingGuard
        when={hasChanges && !btnDisabled}
        shouldBlockNavigation={() => true}
        onExit={() => null}
      />
      <Button
        className="w45p"
        variant="outline-success"
        disabled={btnDisabled}
        onClick={() => {
          const getMessage = () => (
            <div style={{ marginBottom: "20px" }}>
              <span>{`Are you sure you want to discard the changes?`}</span>
            </div>
          );

          confirmAlert({
            customUI: getCustomUi({
              onConfirm: () => {
                setHasChanges(false);
              },
              confirmCTA: "Discard changes",
              cancelCTA: "Cancel",
              getMessage,
            }),
          });
        }}
      >
        Discard changes
      </Button>
      <LoadingTrackedButton
        className="ml-2 btn-create-template w45p"
        variant="success"
        isLoading={loading}
        disabled={btnDisabled}
        onClick={() => {
          if (mode === "create") {
            dispatch(createTemplateFn({ history, action }));
          } else if (mode === "update") {
            dispatch(updateTemplateFn({ history, action }));
          }
          setHasChanges(false);
        }}
      >
        {btnText}
      </LoadingTrackedButton>
    </>
  );
};

export const SaveTemplate = withRouter(SaveTemplate2);
